module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-reset"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require('../assets/img/logo-login.png')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "pass"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "left-start"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Use at least 8 characters including "), _c('u', [_vm._v("Lowercase, Uppercase Numbers "), _c('br'), _vm._v("and Special Characters")]), _vm._v(". Don’t use a password from another site, "), _c('br'), _vm._v("phrases from "), _c('u', [_vm._v("Username")]), _vm._v(" or something too obvious like your pet’s name.")]), _vm._v(" "), _c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pass", $$v)
      },
      expression: "ruleForm.pass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large",
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.passwordReset('ruleForm')
      }
    },
    model: {
      value: (_vm.ruleForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkPass", $$v)
      },
      expression: "ruleForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.pass),
      expression: "ruleForm.pass"
    }],
    ref: "meter",
    attrs: {
      "percentage": _vm.currentStrength.percentage,
      "status": _vm.currentStrength.status
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('div', {
    staticClass: "curve-down-area"
  }), _vm._v(" "), _c('div', {
    staticClass: "down-curve down-curve2"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-page-container"
  }, [_c('div', {
    staticClass: "form-reset"
  }, [_c('el-row', {
    staticClass: "submit_button"
  }, [_c('el-button', {
    staticClass: "btn-lg",
    staticStyle: {
      "margin-bottom": "10px",
      "width": "480px"
    },
    attrs: {
      "type": "submit",
      "size": "large"
    },
    domProps: {
      "textContent": _vm._s(_vm.changing ? 'Changing..' : 'Change Password')
    },
    on: {
      "click": function($event) {
        _vm.passwordReset('ruleForm')
      }
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Error",
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold"
    }, [_vm._v(_vm._s(messageError)), _c('br')])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-284f8000"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 591
// module chunks = 1